// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"SubmitDeliverRequest_pageHolder__1lubW","SubmitButtonHolder":"SubmitDeliverRequest_SubmitButtonHolder__3VK1r"};